<template>




	<div class="container-fluid n10">
		<v-container class="px-1 mx-auto">
			<v-row class="primaryContainer--text mb-5 d-flex align-center flex-row justify-content-between">
				<v-text class="text-h3 font-weight-bold">Destacados</v-text>

				<v-col v-if="$vuetify.breakpoint.mdAndUp" cols="2" class="d-flex justify-end">
					<v-btn fab small color="surface" class="d-none d-sm-none d-md-flex mr-3" @click="prev"
					aria-label="Anterior">
						<v-icon color="onPrimaryContainer">mdi-chevron-left</v-icon>
					</v-btn>
					<v-btn fab small color="surface" class="d-none d-sm-none d-md-flex" @click="next" aria-label="Siguiente">
						<v-icon color="onPrimaryContainer">mdi-chevron-right</v-icon>
					</v-btn>
				</v-col>
			</v-row>

			<VueSlickCarousel ref="slick" v-bind="settings">


				<v-slide-item class="px-4" v-for="evento in eventos" :key="evento.id">

					<router-link :to="{ name: 'evento', params: { evento: evento.slug, }, }">



						<v-card dark flat :width="$vuetify.breakpoint.mdAndUp ? 240 : 160"
							class="d-flex fill-higth  flex-column rounded-lg custom-card n10 ">

							<v-img :min-width="$vuetify.breakpoint.mdAndUp ? 240 : 160"
								v-for="(imagen, index) in evento.imagens.filter(img => img.nombre.includes('imagen_card_mobile'))"
								:key="index" :aspect-ratio="2 / 3" fill-height class="rounded-lg pa-0 ma-0 img-animation"
								:src="imagen.url">


							</v-img>
							<v-row class="ml-2">
								<v-col class="d-flex flex-column justify-content-center px-2 rounded-lg ">
									<v-text>
										<h3 class="primaryContainer--text m-mb-0 pa-0 text-body-1 font-weight-bold text-wrap ">
											{{ evento.nombre }}
										</h3>
										<p class="mb-0 body-2 text-no-wrap">
											{{ formatFecha(evento.fecha_evento) }}
										</p>
									</v-text>
									<v-spacer></v-spacer>
									<v-text class="mt-0 body-2">{{
										evento.tipoevento.nombre
									}}</v-text>
									<v-card-subtitle height="16" class="p-0 mb-8 mb-md-0 m-0">
										<v-icon color="success" fill-height size="10">mdi-checkbox-blank-circle</v-icon>
										Disponible
									</v-card-subtitle>
									<v-spacer></v-spacer>
									<!-- <router-link :to="{
											name: 'evento',
											params: {
												evento: evento.slug,
											},
										}">
											<v-btn block class="custom-btn  mt-md-2 d-none d-sm-none d-md-flex" rounded
												color="primary">
												Comprar Entradas
											</v-btn>
										</router-link> -->
								</v-col>
							</v-row>
						</v-card>


					</router-link>

				</v-slide-item>


			</VueSlickCarousel>
			<!-- <v-slide-group v-if="$vuetify.breakpoint.mdAndUp" ref="slideGroup" v-model="model" center-active
				class="ma-0 pa-0">
				<v-slide-item v-for="evento in eventos" :key="evento.id" class="ma-0 pa-0">

					<router-link :to="{ name: 'evento', params: { evento: evento.slug, }, }">
						<v-col>


							<v-card dark outlined :width="560"
								class="d-flex fill-higth flex-md-row flex-column rounded-lg custom-card ">

								<v-img min-width="256"
									v-for="(imagen, index) in evento.imagens.filter(img => img.nombre.includes('imagen_card_mobile'))"
									:key="index" :aspect-ratio="2 / 3" fill-height class="rounded-lg pa-0 ma-0 img-animation"
									:src="imagen.url">


								</v-img>
								<v-row class="ml-2">
									<v-col class="d-flex flex-column justify-content-center px-2 rounded-lg ">
										<v-text>
											<h3 class="primaryContainer--text m-mb-0 pa-0 text-body-1 font-weight-bold text-wrap ">
												{{ evento.nombre }}
											</h3>
											<p class="mb-0 body-2 text-no-wrap">
												{{ formatFecha(evento.fecha_evento) }}
											</p>
										</v-text>
										<v-spacer></v-spacer>
										<v-text class="mt-0 body-2">{{
											evento.tipoevento.nombre
										}}</v-text>
										<v-card-subtitle height="16" class="p-0 mb-8 mb-md-0 m-0">
											<v-icon color="success" fill-height size="10">mdi-checkbox-blank-circle</v-icon>
											Disponible
										</v-card-subtitle>
										<v-spacer></v-spacer>
										<router-link :to="{
											name: 'evento',
											params: {
												evento: evento.slug,
											},
										}">
											<v-btn block class="custom-btn  mt-md-2 d-none d-sm-none d-md-flex" rounded
												color="primary">
												Comprar Entradas
											</v-btn>
										</router-link>
									</v-col>
								</v-row>
							</v-card>

						</v-col>
					</router-link>

				</v-slide-item>
			</v-slide-group> -->
		</v-container>
	</div>



</template>
<script>

import VueSlickCarousel from 'vue-slick-carousel'
import 'vue-slick-carousel/dist/vue-slick-carousel.css'
import 'vue-slick-carousel/dist/vue-slick-carousel-theme.css'
import moment from "moment";


export default {
	name: 'MyComponent',
	components: { VueSlickCarousel },

	data() {
		return {
			hover: false,
			giras: [],
			settings: {
				"dots": false,
				"infinite": true,
				"slidesToShow": 2,
				"slidesToScroll": 2,
				"variableWidth": true,
				"adaptiveHeight": true,
				"responsive": [
					{
						"breakpoint": 960,
						"settings": {
							"dots": false,
							"slidesToShow": 3,
							"slidesToScroll": 2,
							"infinite": true,

						}
					},
					{
						"breakpoint": 750,
						"settings": {
							"dots": false,
							"infinite": true,
							"slidesToScroll": 2,
							"initialSlide": 2
						}
					},
					{
						"breakpoint": 600,
						"settings": {
							"dots": false,
							"slidesToShow": 2,
							"slidesToScroll": 2,
							"initialSlide": 2
						}
					},

				]
			}
		};
	},
	props: ["eventos"],
	methods: {

		verEvento(id) {
			this.$router.push({
				name: "evento",
				params: { evento: id },
			});
		},
		next() {
			this.$refs.slick.next();
		},

		prev() {
			this.$refs.slick.prev();
		},
		/* next() {

			this.$refs.slideGroup.$nextTick(() => {
				this.$refs.slideGroup.scrollTo('next');
			});
		},
		prev() {

			this.$refs.slideGroup.$nextTick(() => {
				this.$refs.slideGroup.scrollTo('prev');
			});
		}, */
		formatFecha(fecha) {
			if (fecha != null && fecha != "") {
				return moment(fecha).format("MMMM, DD YYYY");
			} else {
				return "";
			}
		},

	},
	mounted() { },
	created() {
	},
};
</script>
<style>
.v-card {
	margin: 0px;
	padding: 0px;
}

.titulo-destacado {
	color: var(--Schemes-Primary-Container, #ffdf6c);
	font-family: Montserrat;
	font-size: 45px;
	font-style: normal;
	font-weight: 500;
	line-height: 52px;
}

* {
	font-family: "Montserrat", "Cabin", sans-serif;
	line-height: 20px;
	/* 142.857% */
	letter-spacing: 0.1px;
	text-transform: none;
}

.v-card-title .manual {
	hyphens: manual;
}

.custom-card {
	transition: transform 0.5s ease-in-out;
	;
}

.custom-card:hover {


	transform: scale(1.02);
}

.pointer-event {
	cursor: pointer;
}

.v-slide-group__prev,
.v-slide-group__next,
.slick-arrow,
.slick-prev,
.slick-next {
	display: none !important;
}
</style>
